import { RunStatus } from "common";

export interface FilterCriteria {
  id: string;
  field: string;
  value: string;
}

export interface FilterFieldOption {
  label: string;
  value: string;
  inputType: "text" | "select" | "multi-select";
}

export const FILTER_FIELD_OPTIONS: FilterFieldOption[] = [
  { label: "Run Name", value: "name", inputType: "text" },
  { label: "Pipeline Name", value: "pipelineName", inputType: "text" },
  { label: "Username", value: "username", inputType: "text" },
  { label: "Run Status", value: "status", inputType: "select" },
  { label: "Scheduler", value: "schedulerId", inputType: "select" },
  { label: "Tag", value: "tag", inputType: "select" },
];

export const RUN_STATUS_OPTIONS = [
  { label: "Success", value: RunStatus.NextSuccess },
  { label: "Error", value: RunStatus.NextError },
  { label: "Running", value: RunStatus.NextRun },
  { label: "Waiting", value: RunStatus.Waiting },
  { label: "Init", value: RunStatus.Init },
  { label: "Terminated", value: RunStatus.Terminated },
  { label: "Aborted", value: RunStatus.Aborted },
  { label: "Manual", value: RunStatus.Manual },
];
